module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct para-style-override-3",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Ruddy_Gore2#Contents-A"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("With thanks to Jean Greenwood of the tireless feet, Foong Ling Kong, Jenny Pausacker, Richard Revill, David Greagg, Themmy Garner (ol’ pal, ol’ buddy), Laurie (cariad) Horner, Matthew Gordon-Clark and the inimitable Jan Gordon-Clark, Tim Daly, Dr Andrea Walker, Brian Di Caffa, Sarah Jane Reeh, Stuart Reeh, Arnold Pears, the memory of my great-uncle Gwilym Davies, the Chinese Museum, the Performing Arts Museum, the management of Her Majesty’s Theatre and the archives of the Victoria Police.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dee91c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ruddy_Gore-4.vue
// module id = 69
// module chunks = 0